import { Header } from "@tanstack/react-table";
import React, { useState } from "react";
import Select from "react-select";

import { CustomDropdownWithChevron } from "../..";
import { customSelectStyles } from "../../../shared/Constants";
import { SelectField } from "../../../types";

type FilterProps = {
  filterOptions: SelectField[];
  placeholderText: string;
  header: Header<Record<string, unknown>, unknown>;
};

export const DropdownFilter: React.FC<FilterProps> = ({
  header,
  filterOptions,
  placeholderText,
}: FilterProps): JSX.Element => {
  const [filterValue, setFilterValue] = useState<SelectField>({
    value: "",
    label: "",
  });

  const column = header?.column;
  const dropdownFilterId = placeholderText.toLowerCase().replace(/ /g, "-");

  return (
    <div
      className="flex flex-col justify-center static w-44 h-full ml-4"
      data-testid="dropdown-filter-container"
    >
      <Select
        name="dropdown-filter"
        aria-labelledby="dropdown-filter-aria-label"
        inputId="dropdown-filter"
        id={`${dropdownFilterId}-filter-select`}
        classNamePrefix={`${dropdownFilterId}-filter-select`}
        options={filterOptions}
        value={
          filterValue.value !== "" && filterValue.label !== ""
            ? filterValue
            : null
        }
        isSearchable={false}
        styles={customSelectStyles}
        placeholder={placeholderText}
        components={{
          DropdownIndicator: CustomDropdownWithChevron,
          IndicatorSeparator: () => null,
        }}
        data-testid={`${dropdownFilterId}-filter-select`}
        onChange={(option) => {
          if (column) {
            if (option) {
              setFilterValue(option);
              column.setFilterValue(option.value || "");
            } else {
              // Handle clearing the filter
              setFilterValue({ value: "", label: "" });
              column.setFilterValue("");
            }
          }
        }}
      />
    </div>
  );
};
